module.exports = __webpack_public_path__ + "img/metalShortBackground.8912511c.png";